import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Select, Modal, Button, Input, Icon, Table } from 'antd'

@inject((store: any) => {
    const { popupStore, termCollectionsStore, companiesStore, policiesStore } = store
    return { popupStore, termCollectionsStore, companiesStore, policiesStore }
})
@observer
export default class AddTermCollection extends Component<any, any> {
    state: any = {
        errors: {},
        company: undefined,
        selectPolicy: false
    }

    componentDidMount() {
        this.props.companiesStore.getCompanies()
    }

    togglePolicySelect = () => {
        this.setState(prevState => ({ selectPolicy: !prevState.selectPolicy }))
    }

    handleCompanyChange = async company => {
        if (company) {
            this.setState({ company })
            await this.props.policiesStore.getList({ company_id: company })
        } else {
            this.setState({ company: undefined })
            this.togglePolicySelect()
        }
    }

    handleSelectPolicy = id => {
        this.props.termCollectionsStore.changeValue('policy_id', id)
        this.setState({ company: undefined, selectPolicy: false })
    }

    handleSubmit = async () => {
        const { edit, submit } = this.props.termCollectionsStore
        if (!edit.policy_id) {
            this.setError('policyError', '* עליך לבחור פוליסת ביטוח')
        } else {
            try {
                await submit()
                this.closePopup()
            } catch (e) {
                if (e.response.status === 403) {
                    this.setError('policyError', '* שיוך לפוליסה זו כבר קיים')
                } else {
                    this.setError('policyError', '* שגיאה בחיבור לשרת')
                }
            }
        }
    }

    setError = (name, value) => {
        this.setState({ errors: { [name]: value } })
    }

    closePopup = () => {
        this.setState({ company: undefined, errors: {}, selectPolicy: false })
        this.props.termCollectionsStore.resetEdit()
        this.props.policiesStore.resetLists()
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const { popupStore, companiesStore, policiesStore } = this.props
        const { loading, edit, changeValue } = this.props.termCollectionsStore
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
                <Button type="primary" disabled={loading} onClick={() => this.handleSubmit()}>
                    {loading ? <Icon type="loading" /> : ''}
                    קשר פוליסה
                </Button>
            </div>
        )

        const columns = [
            {
                title: 'מזהה',
                key: 'id',
                width: 50,
                align: 'right',
                render: (_, record) => (
                    <a
                        target="_blank"
                        style={{ textDecoration: 'underline' }}
                        href={`/insurance/${this.state.company}/${record.id}`}
                    >
                        {record.id}
                    </a>
                )
            },
            {
                title: 'שם הפוליסה',
                key: 'name',
                align: 'right',
                render: (_, record) => record.name
            },
            {
                key: 'choose',
                align: 'right',
                render: (_, record) => (
                    <a style={{ textDecoration: 'underline' }} onClick={() => this.handleSelectPolicy(record.id)}>
                        בחר
                    </a>
                )
            }
        ]

        return (
            <Modal
                title={`הוספת שיוך פוליסה`}
                visible={popupStore.popupType === 'addTermCollection'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                <div style={{ padding: '0.5rem', backgroundColor: '#f1f1f1', marginBottom: '1rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <strong style={{ fontSize: '1rem' }}>
                            {edit.policy_id ? `מזהה פוליסה לקישור: ${edit.policy_id}` : 'אין פוליסה מקושרת'}
                        </strong>
                        {!this.state.selectPolicy ? (
                            <a
                                style={{ color: '#e77910', fontWeight: 'bold', textDecoration: 'underline' }}
                                onClick={() => this.togglePolicySelect()}
                            >
                                {edit.policy_id ? 'שינוי פוליסה' : 'בחירת פוליסה'}
                            </a>
                        ) : (
                            ''
                        )}
                    </div>

                    {this.state.selectPolicy ? (
                        <Select
                            style={{ width: '100%', marginTop: '1rem' }}
                            placeholder="בחר חברה לקבלת רשימת פוליסות"
                            value={this.state.company}
                            onChange={e => this.handleCompanyChange(e)}
                        >
                            <Select.Option value={null}>--</Select.Option>
                            {companiesStore.list.map((company, index) => (
                                <Select.Option key={index} value={company.id}>
                                    {company.name}
                                </Select.Option>
                            ))}
                        </Select>
                    ) : (
                        ''
                    )}
                    {this.state.company ? (
                        <Fragment>
                            <Input.Search
                                placeholder="חיפוש פוליסה על פי שם או מזהה"
                                value={policiesStore.filterText}
                                onChange={e => policiesStore.setFilterText(e.target.value)}
                            />
                            <Table
                                rowKey="id"
                                pagination={{
                                    pageSize: 5
                                }}
                                columns={columns}
                                dataSource={policiesStore.filteredList}
                            />
                        </Fragment>
                    ) : (
                        ''
                    )}
                </div>
                {this.state.errors.policyError ? (
                    <div
                        style={{
                            backgroundColor: '#b31717',
                            color: 'white',
                            padding: '0.5rem',
                            fontWeight: 'bold',
                            marginBottom: '1rem'
                        }}
                    >
                        {this.state.errors.policyError}
                    </div>
                ) : (
                    ''
                )}
                <label>
                    <strong>השתתפות עצמית</strong>
                </label>
                <Input
                    placeholder="הזן ערך טקסטואלי"
                    value={edit.deductible}
                    onChange={e => changeValue('deductible', e.target.value)}
                />
            </Modal>
        )
    }
}
